export const colors = {
    lightWhite: '#F9F9F9',
    white:'#FFFFFF',
    inputWhite:'#F5F5F5',
    inputBorderWhite:'#DEDFDF',
    inputFeild:'rgba(72, 72, 72, 0.5)',
    // brown:'#795F2F',
    brown: '#249393', // official colors
    // brown:'rgb(141, 27, 17)',
    black: '#000000',
    textLight: 'rgba(72, 72, 72, 0.5)',
    textMed:'rgba(113, 115, 118, 1)',
    veryHot:'#E80B0B',
    hot:'#E04241',
    moderate:'#FABC0B',
    cold:'#02BFCD',
    veryCold:'#2D7AF4',
    text:'#12151B',
    textBlue:'#0072FD',
    starYellow:'#FCC01C',
    purple:'#6F51CC'
}

// Enhanced chart colors and design system
export const chartColors = {
  primary: '#249393',        // Your brand color
  secondary: '#0072FD',      // Blue accent
  success: '#28a745',        // Green for positive metrics
  warning: '#FABC0B',        // Yellow for warnings
  danger: '#E80B0B',         // Red for critical metrics
  info: '#02BFCD',           // Cyan for information
  
  // Gradient variations
  gradients: {
    primary: ['#249393', '#1a6b6b'],
    secondary: ['#0072FD', '#0056b3'],
    success: ['#28a745', '#1e7e34'],
    warning: ['#FABC0B', '#e0a800'],
    danger: ['#E80B0B', '#c82333']
  },
  
  // Lead classification colors (enhanced)
  leadClassification: {
    veryHot: '#E80B0B',
    hot: '#E04241', 
    moderate: '#FABC0B',
    cold: '#02BFCD',
    veryCold: '#2D7AF4'
  }
}

// Typography system for charts
export const chartTypography = {
  title: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#12151B',
    marginBottom: '1rem'
  },
  subtitle: {
    fontSize: '0.875rem',
    fontWeight: '500',
    color: 'rgba(113, 115, 118, 1)',
    marginBottom: '0.5rem'
  },
  label: {
    fontSize: '0.75rem',
    fontWeight: '400',
    color: 'rgba(72, 72, 72, 0.7)'
  }
}